import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Routes from '../routes';
import PageApp from './Layouts/PageApp';

import { resetUserMessages } from '../actions/userMessages';

import UnhandledError from '../components/UnhandledError';

export class App extends Component {
  componentDidUpdate(prevProps) {
    const {
      location: { pathname: nextPage },
      handleResetUserMessages,
      messageShown,
    } = this.props;
    const { location: { pathname: prevPage } } = prevProps;

    if (prevPage !== nextPage) {
      if (messageShown) {
        handleResetUserMessages();
      }
    }
  }

  renderAppState() {
    return <Routes {...this.props} />;
  }

  render() {
    const {
      showModal,
      handleResetUserMessages,
    } = this.props;

    return (
      <PageApp>
        {showModal && <UnhandledError closeModal={handleResetUserMessages} />}
        {this.renderAppState()}
      </PageApp>
    );
  }
}

const mapStateToProps = ({
  userMessages: { showModal, messageShown },
  auth: {
    macaroon: { guid },
    accountPerms = [],
  },
}) => ({
  guid,
  showModal,
  messageShown,
  isPrimary: accountPerms.indexOf('PRIMARY') !== -1,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleResetUserMessages: resetUserMessages,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
